import { trim } from "@/helpers/string.helpers"
import { PayloadHandler, type Values } from "./payload.handler"

export class DetailsHandler extends PayloadHandler {
  public handle(request: Values) {
    const { name_details, description_details, ...rest } = request

    return super.handle({
      name: trim(name_details),
      description: trim(description_details),
      ...rest
    })
  }
}
